module.exports = __webpack_public_path__ + "static/media/UsersSample.10627afc.csv";